import { useFeatureFlag } from '@moda/portal-stanchions';
import { useEffect } from 'react';
import { tc } from '../../lib/trackingContext';

export type AuthMethod = 'password' | 'passwordless';
export type AuthLocation =
  | 'standard_login'
  | 'checkout'
  | 'convert_guest'
  | 'order_confirmation'
  | 'magic_link_confirmation';

type UseAuthMethodArgs = {
  authMethod?: AuthMethod;
  authLocation?: AuthLocation;
};

export const useAuthMethod = ({ authMethod, authLocation }: UseAuthMethodArgs = {}): AuthMethod => {
  const passwordlessEnabled = useFeatureFlag('passwordless-login', [
    { default: false },
    { if: true, then: true }
  ]);

  const currentAuthMethod = authMethod ?? (passwordlessEnabled ? 'passwordless' : 'password');

  useEffect(() => {
    tc.setCurrent('auth_method', currentAuthMethod);
    tc.setCurrent('auth_location', authLocation);

    return () => {
      tc.setCurrent('auth_method', undefined);
      tc.setCurrent('auth_location', undefined);
    };
  }, [authLocation, currentAuthMethod]);

  return currentAuthMethod;
};
